import constants from 'constants'

export function getCurrentPageData(currentPage, data) {
  const offset = currentPage * constants.PAGINATION_PER_PAGE
  const currentPageData = data.length >= constants.PAGINATION_PER_PAGE ? data.slice(offset, offset + constants.PAGINATION_PER_PAGE) : data
  const pageCount = Math.ceil(data.length / constants.PAGINATION_PER_PAGE);
  return {
    currentPageData,
    pageCount,
  }
}



// WEBPACK FOOTER //
// ./src/utils/paging.js